
<div class="d-md-flex align-items-center bg-white p-3">
  <span class="d-flex align-items-center p-2 ">
    <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"> Totale {{ 'menu.PersonaleLabel' | translate}}:</h5>
    <span *ngIf='contactFilter'
      class="badge badge-danger badge-pill px-3 font-weight-bold font-14">{{collectionSize}}</span>
  </span>
  <div class="ml-auto mt-3 mt-md-0">
    <button type="button" class="btn btn-cyan rounded-pill py-2" *ngIf="permission.isPermitted('gestione-persone')" (click)='addContact()'><i
        class="fas fa-plus  font-14 mr-1 text-white"></i>
      <span class="ml-1 text-white font-weight-bold">Aggiungi</span>
    </button>
  </div>
</div>

<div class="d-md-flex align-items-center border-top bg-white p-3">

    <div class="input-group col-9 ">
      <div class="input-group-prepend">
        <label class="input-group-text" >Cerca</label>
      </div>
      <input [(ngModel)]="filtri.nome" (ngModelChange)="Search()" type="text" name="cerca" class="form-control">
    </div>
    <div class="input-group col-3">
      <div class="input-group-prepend ">
        <label class="input-group-text" >Elementi</label>
      </div>
      <select class="custom-select" [(ngModel)]="N_Elementi" (ngModelChange)="sizeChanged()" >
        <option value="1">1</option>
        <option value="10">10</option>
        <option value="25">25</option>
        <option selected value="50">50</option>
        <option value="100">100</option>
        <option value="200">200</option>
        <option value="500">500</option>
        <option value="1000">1000</option>
      </select>
    </div>
  </div>


<div class=" border-top bg-white p-3">
    <app-field-viewer  [(Oggetto)]="filtri" [(Campi)]="environment['Personale']['filtri']" (OnChange)="FilterChange($event)" [(DropdownSources)]="DropdownSources"></app-field-viewer>
</div>
<div class="table-responsive" *ngIf="environment['Personale'] && environment['Personale']['Headers']">
  <table class="table bg-white table-hover align-middle mb-0">
    <thead>
      <tr>
        <ng-container *ngFor="let campo of environment['Personale']['Headers']">
          <th scope="col" [ngStyle]="campo.titleStyle" [ngClass]="campo.titleClass" (click)="order(campo)"
            *ngIf="permission.isntOperativeRoles(campo.prohibitedRoles) && permission.isOperativeRoles(campo.AllowedRoles) && headShow(campo)">
            {{campo.nome}}</th>
        </ng-container>
        <th scope="col" [ngStyle]="environment.ClientiAddOn['headerStyle']">Azioni</th>
      </tr>
    </thead>
      <tbody>
        <tr *ngFor="let item of contactFilter | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
          <ng-container *ngFor="let campo of environment['Personale']['Headers']">
       
              <td class="align-middle" (click)='editContact(item)' *ngIf="headShow(campo)">
                <span class="font-14" [ngClass]="{'badge badge-pill px-3': campoUtility.Colore(campo,item) }"
                  [ngStyle]="{'color': campoUtility.Colore(campo,item)?  LightenColor(campoUtility.Colore(campo,item)) : '', 'background-color': campoUtility.Colore(campo,item)}">
                  <ng-container *ngFor="let oggetto of campo.oggetti; let i = index">
                    <ng-template [ngIf]="campo.type!= 'object' && campo.inputType == 'date' && item[oggetto]">
                      {{campoUtility.getObj(item, oggetto) | date: 'dd/MM/yyyy'}} &nbsp;
                    </ng-template>
                    <ng-template [ngIf]="campo.type == 'object' && campo.inputType == 'date' && campoUtility.getObj(item, oggetto) ">
                      {{campoUtility.getObj(item, oggetto)[campo.field[i]] | date: 'dd/MM/yyyy'}} &nbsp;
                    </ng-template>
                    <ng-template [ngIf]="campo.type!= 'object' && campo.inputType == 'datetime-local' && item[oggetto]">
                      {{campoUtility.getObj(item, oggetto) | date: 'dd/MM/yyyy HH:mm'}} &nbsp;
                    </ng-template>
                    <ng-template
                      [ngIf]="campo.type == 'object' && campo.inputType == 'datetime-local' && campoUtility.getObj(item, oggetto)">
                      {{campoUtility.getObj(item, oggetto)[campo.field[i]] | date: 'dd/MM/yyyy HH:mm'}} &nbsp;
                    </ng-template>
                    <ng-template
                      [ngIf]="campo.type!= 'object' && campo.inputType != 'date' && campo.inputType != 'datetime-local' && campo.type != 'replace' && campo.type != 'objArray'">
                      {{campoUtility.getObj(item, oggetto)}} &nbsp;
                    </ng-template>
                    <ng-template
                      [ngIf]="campo.type == 'object' && campo.inputType != 'date' && campo.inputType != 'datetime-local' && item[oggetto] && campoUtility.getObj(item, oggetto)">
                      {{campoUtility.getObj(item, oggetto)[campo.field[i]]}} &nbsp;
                    </ng-template>
                    <ng-template
                      [ngIf]="campo.type == 'object' && campo.inputType != 'date' && campo.inputType != 'datetime-local' && !item[oggetto] && campo.oggettisec && campo.oggettisec[i] && item[campo.oggettisec[i]]">
                      {{item[campo.oggettisec[i]][campo.field[i]]}} &nbsp;
                    </ng-template>
                    <ng-template [ngIf]="campo.type == 'replace' ">
                      {{campoUtility.Replace(campo, item, oggetto)}} &nbsp;
                    </ng-template>
                    <ng-template [ngIf]="campo.type == 'objArray' ">
                      <ng-container *ngFor="let obg of campoUtility.getObj(item, oggetto)">
                        {{obg[campo.field[i]]}} &nbsp;
                      </ng-container>
                    </ng-template>
                  </ng-container>
                </span>
              </td>
              
          </ng-container>
      
          <td class="align-middle" *ngIf="permission.isPermitted('gestione-persone')">
            <a href="javascript:void(0)" class="link font-16 text-info font-medium mr-2" (click)='editContact(item)'>
              <i-feather name="edit-3" class="feather-sm"></i-feather>
            </a>
            <a *ngIf="item.enabled" href="javascript:void(0)" class="link font-16 text-danger font-weight-bold"
              (click)='deleteUser(item)'>
              <i-feather name="trash-2" class="feather-sm"></i-feather>
            </a>
            <a *ngIf="!item.enabled" href="javascript:void(0)" class="link font-16 text-orange font-weight-bold"
              (click)='renewUser(item)'>
              <i-feather name="plus" class="feather-sm"></i-feather>
            </a>
          </td>
      
        </tr>
      </tbody>
  </table>
</div>

<div class="table-responsive" *ngIf="!environment['Personale'] || !environment['Personale']['Headers']">
  <table class="table bg-white table-hover align-middle mb-0 no-wrap">
    <thead>
      <tr>
        <th (click)="filterByName()">
          Nome
          <i *ngIf="orderName === 'asc'"  class=" fas fa-caret-up"></i>
          <i *ngIf="orderName === 'desc'" class=" fas fa-caret-down"></i>
        </th>
        <th scope="col">Email</th>
        <th scope="col">Numero di telefono</th>
        <th scope="col" *ngIf="!environment['Personale']['hideRuoloHeader']">Ruolo</th>
        <th scope="col" *ngIf="permission.isPermitted('gestione-persone')">Azioni</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let co of contactFilter | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize | noAdminFilter:''">
        <td (click)='editContact(co)'>
          <span class="text-dark font-medium font-16">{{ co.cognome }} {{co.nome}}</span>
        </td>
        <td class="align-middle">
          <span>
<!--            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">-->
              <i-feather name="Mail" class="feather-sm"></i-feather> &nbsp;
<!--            </span>-->
            <a href="mailto:{{co.email}}">
              {{ co.email }}
            </a>
          </span>
        </td>
        <td class="align-middle" (click)='editContact(co)'>
          <span>
<!--            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">-->
              <i-feather name="phone" class="feather-sm"></i-feather> &nbsp;
<!--            </span>-->
            {{ (co.telefono ?? "") + "  " + (co.cellulare ?? "")  }}
          </span>
        </td>
        <td *ngIf="!environment['Personale']['hideRuoloHeader']" class="align-middle position-relative" (click)='editContact(co)'>
          <span>
<!--            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">-->
              <i-feather name="Briefcase" class="feather-sm"></i-feather> &nbsp;
<!--            </span>-->
            <label *ngFor="let ruolo of co.ruoliObject">{{ ruolo.label}} &nbsp;<br></label>
          </span>
        </td>
        <td class="align-middle" *ngIf="permission.isPermitted('gestione-persone')">
          <a href="javascript:void(0)" class="link font-16 text-info font-medium mr-2" (click)='editContact(co)'>
            <i-feather name="edit-3" class="feather-sm"></i-feather>
          </a>
          <a *ngIf="co.enabled"  href="javascript:void(0)" class="link font-16 text-danger font-weight-bold" (click)='deleteUser(co)'>
            <i-feather name="trash-2" class="feather-sm"></i-feather>
          </a>
          <a *ngIf="!co.enabled" href="javascript:void(0)" class="link font-16 text-orange font-weight-bold" (click)='renewUser(co)'>
            <i-feather name="plus" class="feather-sm"></i-feather>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>


<div class="d-flex justify-content-center p-2 pt-3 bg-white border-top">
  <ngb-pagination (pageChange)="getPage($event)" id="paginationComponent" [maxSize]="10"
    [collectionSize]="collectionSize" [pageSize]="pageSize">
  </ngb-pagination>
</div>
